<!-- Reusable modal component that will help provide consistent look and functionality -->
<template>
  <b-modal :id="modalId"
           :title="modalTitle"
           :no-close-on-backdrop="true"
           @show="beforeShow"
           @hidden="afterHidden"
  >
    <template>
      <slot>Confirm Action</slot>
      <div slot="modal-footer">
        <b-btn :id="cancelButtonId" variant="outline-secondary" @click="cancel">Cancel</b-btn>
        <b-btn :id="okButtonId" variant="outline-primary" @click="confirm">{{ okButtonTitle }}</b-btn>
      </div>
    </template>
  </b-modal>
</template>

<script>

export default {
  name: 'AppModal',
  data() {
    return {};
  },
  props: {
    modalId: {
      type: String,
      required: true,
    },
    modalTitle: {
      type: String,
      required: false,
      default: 'Confirm',
    },
    okButtonTitle: {
      type: String,
      required: false,
      default: 'Confirm',
    },
  },
  computed: {
    cancelButtonId() {
      return `${this.modalId}-btn-cancel`;
    },
    okButtonId() {
      return `${this.modalId}-btn-ok`;
    },
  },
  methods: {
    cancel() {
      this.$emit('cancel');
      this.$root.$emit('bv::hide::modal', this.modalId);
    },
    confirm() {
      this.$emit('confirm');
    },
    beforeShow() {
      this.$emit('beforeShow');
    },
    afterHidden() {
      this.$emit('afterHidden');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/modals/AppModal.vue